var map = {
	"./common/arrow.svg": 268,
	"./common/chevron.svg": 269,
	"./common/close.svg": 190,
	"./common/contact.svg": 270,
	"./common/download.svg": 271,
	"./common/fullscreen.svg": 272,
	"./common/minimize.svg": 273,
	"./common/play.svg": 274,
	"./common/square.svg": 275,
	"./common/triangle.svg": 276,
	"./common/upload.svg": 277,
	"./download/appstore.svg": 278,
	"./download/googleplay.svg": 279,
	"./lang/br.svg": 280,
	"./lang/en.svg": 281,
	"./lang/mm.svg": 282,
	"./lang/mx.svg": 283,
	"./lang/ph.svg": 284,
	"./lang/th.svg": 285,
	"./lang/vn.svg": 286,
	"./nav/burger-close.svg": 287,
	"./nav/burger.svg": 288,
	"./platform/desktop.svg": 289,
	"./platform/mobile.svg": 290,
	"./social/facebook-f.svg": 291,
	"./social/facebook-messenger.svg": 292,
	"./social/facebook-share.svg": 293,
	"./social/facebook.svg": 294,
	"./social/instagram.svg": 295,
	"./social/twitter.svg": 296,
	"./social/youtube.svg": 297,
	"./tournament/format.svg": 298,
	"./tournament/game-mode.svg": 299,
	"./tournament/location.svg": 300,
	"./tournament/prize-pool.svg": 301,
	"./tournament/starting-date.svg": 302,
	"./tournament/trophy.svg": 303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 267;